import appsettings from "@/store/app-settings";
import { axiosGet, axiosPost } from "@/store/api/axiosUtils.js";

const getByName = (name) => {
  const params = {
    compName: name,
  };
  return axiosGet(
    appsettings.digtalIdAPIUrl + "api/Company/ByNameDropdown",
    params
  );
};

const getAddressDetail = (id) => {
  const params = {
    id,
  };
  return axiosGet(
    appsettings.digtalIdAPIUrl + "api/Company/GetAddressDetailById",
    params
  );
};

const getById = (id) => {
  const params = {
    compId: id,
  };
  return axiosGet(
    appsettings.digtalIdAPIUrl + "api/Company/byidWithAddress",
    params
  );
};

const getCompanyMOU = (companyIds) => {
  const query = companyIds.map((id) => `ids=${id}`).join("&");

  return axiosGet(
    appsettings.ocpbComplaintAPIUrl + `api/Company/GetCompanyMOU?${query}`
  );
};

const getPagination = (params) => {
  return axiosGet(
    appsettings.ocpbComplaintAPIUrl + "api/Company/Pagination",
    params
  );
};

const getAttorneyList = (params) => {
  return axiosGet(
    appsettings.ocpbComplaintAPIUrl + "api/Company/AttorneyList",
    params
  );
};

export { getByName, getAddressDetail, getById, getCompanyMOU, getPagination, getAttorneyList };
